<div class="epds-full-screen" fxFill fxLayout="column">
  <app-header></app-header>
  <mat-sidenav-container class="epds-app-mat-drawer-container" [autosize]="sidebarService.autosize">
    <mat-sidenav mode="side" #drawer>
      <app-sidebar></app-sidebar>
    </mat-sidenav>
    <mat-sidenav-content>
      <div role="main" fxFill id="mainContent">
        <div *ngIf="stateService.idle_message" class="idle color_warn">{{stateService.idle_message}}</div>
        <router-outlet class="router-flex"></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
